<!--
  PaymentFormModal: alta de pagos con imputación de comprobantes y detalle de medios.

  ENTRADA
    Props: no tiene.
    Métodos públicos (por ref):
      add()              Abre el alta vacía.
      addFromPurchase(query)  Abre el alta con un comprobante de compra preseleccionado. query: { purchase_id, suppliers_id, points_sales_id }.
                         Al guardar o cancelar vuelve a compras.
      close()            Cierra el modal sin confirmar.

  SALIDA
    Eventos:
      @saved(response)   Se guardó. La vista recarga lo que corresponda.
    Efectos:
      Guarda con agregarPagos. GENERA MOVIMIENTOS REALES DE CAJA, cheques e imputación de comprobantes.

  USOS
    Vista: <PaymentFormModal ref="paymentForm" @saved="filterPayments()" />
    Alta:         this.$refs.paymentForm.add()
    Desde origen: this.$refs.paymentForm.addFromPurchase(this.$route.query)
    Hoy se invoca desde payments-erp/staff/payments.vue: botón, ?new=1 de la paleta y el botón de compras.

  DEPENDENCIAS Y PERMISOS
    Componentes: FindObject, FinanceSUB, VoucherExpiration, EmptyState (global).
    La imputación de un pago ya existente sigue en la vista.
    No controla permisos: quien lo invoca decide si el usuario puede abrirlo.
-->
<template>
  <div>
    <!-- CRUD MAIN -->
    <b-modal v-model="modal.form.active"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            size="xl"
            :key="modal.form._id"
            :id="modal.form._id">
      <div slot="modal-header" minimize class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
        <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
      </div>

      <form-wizard  title=""
                    subtitle=""
                    nextButtonText="Siguiente"
                    backButtonText="Atrás"
                    finishButtonText="Guardar"
                    color="#2f353a"
                    shape="tab"
                    @on-complete="save"
                    class="crud-payments-wizard">

        <tab-content title="General" icon="fa fa-edit" :before-change="paymentsValidGeneral">          
          <b-row>      
            <b-col md="4">
              <b-form-group label="Fecha">
                <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>                      
              </b-form-group>            
            </b-col>
          </b-row>              
          <b-row> 
            <b-col md="5">
              <FindObject render="search"
                          type="suppliers" 
                          @select-object="loadSuppliers($event)" 
                          :valueID="crud.form.suppliers_id"
                          :where="conditionSuppliersActive"
                          :disabled="crud.form.id>0" />                 
            </b-col>    
            <b-col md="3">
              <FindObject render="search"
                          type="erpPointsSales" 
                          auto-select-single
                          display="full_identification"
                          @select-object="loadPointsSales($event)" 
                          :valueID="crud.form.points_sales_id"
                          :key="crud.form.points_sales_id"
                          :disabled="crud.form.id>0" 
                          :where="conditionPointsSalesActive" />                 
            </b-col>
          </b-row>
          <b-row v-if="balanceCurrentAccount>0">
            <b-col>
              <b-alert show variant="success">
                Se encontró saldo a favor: <b>({{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(balanceCurrentAccount)}})</b>
              </b-alert>
            </b-col>
          </b-row>            
        </tab-content>
        
        <tab-content title="Imputación" icon="fa fa-paperclip" :before-change="paymentsValidImputation">                      
          <b-row>
            <b-col lg="12" md="12" sm="12">
              <b-table-simple hover small caption-top responsive v-if="arr.pending.length" class="app-table app-table--compact app-table--stacked-manual crud-payments-table-items">
                <b-thead>
                  <b-tr>
                    <b-th width="10%" class="text-left">Imputar</b-th>
                    <b-th width="12%" class="text-left">Fecha</b-th>
                    <b-th width="16%" class="text-left">Vencimiento</b-th>
                    <b-th width="22%" class="text-left">Comprobante</b-th>
                    <b-th width="5%" class="text-center"><span class="sr-only">Información de pago</span></b-th>
                    <b-th width="10%" class="text-right">Total</b-th>
                    <b-th width="10%" class="text-right">Pendiente</b-th>
                    <b-th width="15%" class="text-center">A Imputar</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody v-for="(item, index) in arr.pending" :key="item.id">
                  <b-tr :key="itemForceUpdate" v-if="crud.formPending[index]">
                    <b-td data-label="Imputar" :class="'align-middle ' + alignClass('text-left')">
                      <b-form-checkbox v-model="crud.formPending[index].check"
                                        @change="validCheck(index)"
                                        switch
                                        size="sm"
                                        class="pull-left">
                      </b-form-checkbox>
                    </b-td>
                    <b-td data-label="Fecha" :class="'align-middle ' + alignClass('text-left')">
                      {{moment(item.date).format('DD/MM/YYYY')}}
                    </b-td>
                    <b-td data-label="Vencimiento" :class="'align-middle ' + alignClass('text-left')">
                      <VoucherExpiration :date="item.date_expiration"
                                         :pending="item.type_voucher && item.type_voucher.type_balance == '+' && calcVoucherPending(item) > 0" />
                    </b-td>
                    <b-td data-label="Comprobante" :class="'align-middle ' + alignClass('text-left')">
                      {{item.type_voucher.name + ' ' + item.point_sale.toString().padStart(4,'0') + '-' + item.number.toString().padStart(8,'0')}}
                    </b-td>
                    <b-td data-label="Información de pago" :class="'align-middle ' + alignClass('text-center')">
                      <span v-if="item.info_payment"
                            class="crud-payments-info-payment"
                            v-b-tooltip.hover
                            :title="item.info_payment.name">
                        <AppIcon name="sticky_note_2" />
                      </span>
                    </b-td>
                    <b-td data-label="Total" :class="'align-middle ' + alignClass('text-right')">
                      <div class="text-danger" v-if="item.type_voucher.type_balance == '-'">
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}}</b>
                      </div>
                      <div class="text-success" v-else>
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(item.amount_total)}}</b>
                      </div>
                    </b-td>
                    <b-td data-label="Pendiente" :class="'align-middle ' + alignClass('text-right')">
                      <div class="text-danger" v-if="item.type_voucher.type_balance == '-'">
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(calcVoucherPending(item))}}</b>
                      </div>
                      <div class="text-success" v-else>
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: item.currency.code}).format(calcVoucherPending(item))}}</b>
                      </div>
                    </b-td>
                    <b-td data-label="A Imputar" :class="'align-middle ' + alignClass('text-center')">
                      <app-number-input size="sm"
                                    @change="validAmount(index)"
                                    v-model="crud.formPending[index].amount"
                                    placeholder="Ingresar monto a imputar"
                                    class="crud-payments-item-input"
                                    v-if="crud.formPending[index].check" />
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
              <EmptyState v-else icon="paperclip" title="No hay comprobantes pendientes de imputar" />
            </b-col>
          </b-row>
          <b-row align-h="end" class="mb-2">
            <b-col lg="4" md="4" sm="4">
              <b-input-group size="sm" prepend="TOTAL A IMPUTAR">
                <b-form-input :value="imputationFormat"
                              type="text"
                              :readonly="true"
                              class="payments-payments-add-total-final">
                </b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </tab-content>

        <tab-content title="Detalle" icon="fa fa-list" :before-change="paymentsValidPayments">
          <b-row align-h="center"> 
            <b-col lg="4">             
              <FinanceSUB @getFinances="storeFinances($event)" 
                          v-if="crud.form.suppliers_id && crud.form.points_sales_id && crud.form.points_sales"
                          :points_sales="crud.form.points_sales"
                          :amount_impute="imputationAmount"
                          :reset="resetControl"/>              
            </b-col>
          </b-row>
        </tab-content>

        <tab-content title="Observaciones" icon="fa fa-flag-checkered">          
          <b-row>
            <b-col md="12">
              <b-form-group label="Observaciones">
                <app-textarea                
                  v-model="crud.form.observations"
                  placeholder="Ingresar las observaciones..."
                  rows="3"
                  max-rows="6"
                ></app-textarea>
              </b-form-group>
            </b-col>         
          </b-row>
          <b-row v-if="crud.form.payment">
            <b-col>
              <b-alert show variant="warning" v-if="$funciones.compareMoney(crud.form.payment.total, imputationAmount) > 0">
                <AppIcon name="exclamation-triangle" class="mr-1" />El importe pagado es mayor al total de los comprobantes imputado.<br>
                <b>Importe Imputado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(imputationAmount)}}<br>
                <b>Importe Pagado</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(this.crud.form.payment.total)}}<br><br>
                <i>El saldo quedará en cuenta corriente pendiente de imputación a favor de la empresa</i>
              </b-alert>
            </b-col>
          </b-row>             
        </tab-content>

      </form-wizard>
      
      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>              
      </div>                
    </b-modal>
  </div>
</template>
<script>
  import serviceAPI from '../services'
  import Error from '@/handler/error'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'
  import moment from 'moment'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import FinanceSUB from '@/components/inc/finances/sub'
  import VoucherExpiration from '@/components/modules/users/purchase/staff/inc/VoucherExpiration'

  export default {
    name: 'PaymentFormModal',
    components: {
      FindObject,
      FormWizard,
      TabContent,
      FinanceSUB,
      VoucherExpiration,
    },
    data: () => {
      return {
        isMobileViewport: false,
        crud: {
          form: {
            id: 0,
            date: '',            
            types_vouchers_id: 0,
            types_vouchers: null,
            letter: '',
            number: 0,
            points_sales_id: 0,
            points_sales: null,              
            observations: '',            
            staff_id: 0,
            suppliers_id: 0,
            suppliers: null,  
            selectTypeVoucher: 'ordenpago',
            reference_voucher_id: 0,                                                           
            payment: null,
            imputation: [],    
            operation: 'add',
          },                        
          formPending: [],       
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
        },
        arr: {
          pending: [],
        },
        itemForceUpdate: 0,
        resetControl: false,
        calc: {
          positiveBalance: 0,
        },        
        balanceCurrentAccount: 0,
        // Pago iniciado desde una factura de Compras: id de la factura a
        // tildar cuando llegan los pendientes, y a dónde volver al terminar.
        preselectPurchaseId: 0,
        generationOrigin: null,
      }
    },
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    computed: {
      conditionSuppliersActive(){
        return [{field: 'active', condition: true}];
      },  
      conditionPointsSalesActive() {
        return [{field: 'active', condition: true}];
      },  
      getCurrencySymbol() {
        return '$'
      },  
      getCurrencyCode() {
        return 'ARS'
      },  
      imputationAmount() {
        let imputation = 0
        ;(this.crud.formPending || []).forEach(element => {
          if(!element.check) return

          const amount = parseFloat(element.amount) || 0
          imputation += element.operation == '+' ? amount : -amount
        })
        return Math.round(imputation * 100) / 100
      },
      imputationFormat() {
        return Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencyCode}).format(this.imputationAmount)
      },
    },
    watch: {
      'crud.form.suppliers_id': function (newQuestion, oldQuestion) {
        if(this.crud.form.operation == 'add') {
          this.crud.form.payment = null           
          this.crud.form.imputation = []          
          this.resetControl = true

          this.arr.pending = []
          this.crud.formPending = []
          this.balanceCurrentAccount = 0  
                    
          this.obtenerVouchersPendingImputarBySuppliers()
          this.searchVoucherBySupplier()
        }
      },
      'crud.form.points_sales_id': function (newQuestion, oldQuestion) {                
        if(this.crud.form.operation == 'add') {
          this.crud.form.payment = null           
          this.crud.form.imputation = []          
          this.resetControl = true

          this.arr.pending = []
          this.crud.formPending = []
          this.balanceCurrentAccount = 0  
                    
          this.obtenerVouchersPendingImputarBySuppliers()        
          this.searchVoucherBySupplier()
        }
      },
    },
    methods: {
      // API PUBLICA PARA LA VISTA
      close() {
        this.modal.form.active = false
      },

      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      loadSuppliers(object) {        
        if(object){
          this.crud.form.suppliers = object
          this.crud.form.suppliers_id = object.id   
          
          if(object.data_fiscal) {
            if(object.data_fiscal.points_sales_id) {
              if(!this.crud.form.points_sales_id) {
                this.crud.form.points_sales = object.data_fiscal.points_sales
                this.crud.form.points_sales_id = object.data_fiscal.points_sales_id
              }
            }
          }

          this.getBalanceCurrentAccount()
        } else {
          this.crud.form.suppliers = null
          this.crud.form.suppliers_id = 0

          this.balanceCurrentAccount = 0
        }
      }, 
      loadPointsSales(object) {                
        if(object){
          this.crud.form.points_sales = object
          this.crud.form.points_sales_id = object.id           
          
          this.getBalanceCurrentAccount()
        } else {
          this.crud.form.points_sales = null
          this.crud.form.points_sales_id = 0

          this.getBalanceCurrentAccount()
        }
      },
      getBalanceCurrentAccount() {
        var result = serviceAPI.filtrarCurrentsAccountsBalance({
          suppliers_id: this.crud.form.suppliers_id,
          points_sales_id: this.crud.form.points_sales_id, 
        })

        result.then((response) => {
          var data = response.data
          this.balanceCurrentAccount = data
        })
      },

      // ABM MAIN
      add() {
        this.crud.form.operation = 'add'

        this.crud.form.id = 0           
        this.crud.form.date = moment().format('YYYY-MM-DD')        
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.suppliers_id = 0
        this.crud.form.suppliers = null   
        this.crud.form.points_sales_id = 0
        this.crud.form.points_sales = null        
        this.crud.form.types_vouchers_id = 0
        this.crud.form.types_vouchers = null
        this.crud.form.letter = ''
        this.crud.form.number = 0
        this.crud.form.payment = null
        this.crud.form.imputation = []         

        this.crud.formPending = []
        this.arr.pending = []

        this.balanceCurrentAccount = 0       

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Pago"
        this.modal.form.active = true
      },            
      save() {
        this.confirmDialog('¿Desea continuar con la generación del Pago?', {
          title: 'Generar Pago',
          okTitle: 'GENERAR'
        })
        .then(value => {
          if (value) {          
            let loader = this.$loading.show();
              
            var result = serviceAPI.agregarPagos(this.crud.form);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.$emit('saved', response)
              this.$awn.success("Pago generado con éxito");

              this.returnToGenerationOrigin()
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })              
      },          
      cancel() {
        this.confirmDialog('¿Desea cancelar el Pago?', {
          title: 'Cancelar el Pago',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {        
            this.modal.form.active = false

            this.returnToGenerationOrigin()
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })   
      },

      addFromPurchase(query) {
        this.add()
        this.generationOrigin = 'purchase'
        this.preselectPurchaseId = parseInt(query.purchase_id)
        // Ambos en el mismo tick: los FindObject del paso General se montan
        // ya con el valor y cargan proveedor / punto de venta completos.
        this.crud.form.points_sales_id = parseInt(query.points_sales_id)
        this.crud.form.suppliers_id = parseInt(query.suppliers_id)

        // No depender de los watchers: si la pestaña ya estaba abierta con el
        // mismo proveedor / punto de venta, add() los pone en 0 y se
        // restauran en el mismo tick -- Vue no ve cambio y no dispararía la
        // carga. Esta llamada va después del flush, así que es la última y
        // la única respuesta que se aplica.
        this.$nextTick(() => {
          this.obtenerVouchersPendingImputarBySuppliers()
          this.searchVoucherBySupplier()
        })
      },
      returnToGenerationOrigin() {
        var origin = this.generationOrigin
        this.generationOrigin = null
        this.preselectPurchaseId = 0

        if(origin == 'purchase') {
          this.$router.push({ name: 'PurchaseStaffPurchase' }).catch(() => {})
        }
      },

      // FINANCES
      storeFinances(values) {
        this.crud.form.payment = values           
        this.crud.form.payment.totalFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencyCode}).format(this.crud.form.payment.total)
        
        this.calc.positiveBalance = this.crud.form.payment.total 
        this.calc.positiveBalanceFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencyCode}).format(this.calc.positiveBalance)             

        this.resetControl = false
      },

      // VALIDATION STEP
      paymentsValidGeneral() {
        if(this.crud.form.suppliers_id && this.crud.form.points_sales_id) {                            
          return true;
        } else {
          if(!this.crud.form.suppliers_id) {
            this.$awn.alert("No se cargó el proveedor");
            return false;
          }
          if(!this.crud.form.points_sales_id) {
            this.$awn.alert("No se cargó el punto de venta");
            return false;
          }
        }        
      },    
      paymentsValidImputation() {    
        this.loadFormImpuation()
        return true;        
      },       
      paymentsValidPayments() {
        if(this.crud.form.payment) {
          if(this.crud.form.payment.total>0) {
            if(this.$funciones.compareMoney(this.crud.form.payment.total, this.imputationAmount) >= 0) {
              return true
            } else {
              this.$awn.alert("El total del pago no puede ser menor al total imputado");
              return false;                        
            }
          } else {
            this.$awn.alert("No se cargó ningún método de pago");
            return false;          
          }
        } else {
          this.$awn.alert("No se cargó ningún método de pago");
          return false;                    
        }
      },   

      // IMPUTACION COMPROBANTES
      obtenerVouchersPendingImputarBySuppliers() {
        this.crud.formPending = []
        // Proveedor y punto de venta cambian juntos (ej. pago desde una
        // factura) y cada watcher dispara su pedido: sólo vale la última
        // respuesta, si no las filas quedan duplicadas.
        var requestId = this._pendingRequestId = (this._pendingRequestId || 0) + 1
        
        if(this.crud.form.suppliers_id && this.crud.form.points_sales_id) {
          var result = serviceAPI.filtrarPendienteImputar({
            suppliers_id:this.crud.form.suppliers_id, 
            points_sales_id: this.crud.form.points_sales_id,
            hide_note_credit: true,
          })        
          result.then((response) => {
            if(requestId !== this._pendingRequestId) return

            var data = Array.isArray(response.data) ? response.data.slice() : []

            this.crud.formPending = []

            this.arr.pending = data.sort((a, b) => {
              const dateA = moment(a.date).valueOf()
              const dateB = moment(b.date).valueOf()
              if(dateA !== dateB) return dateA - dateB
              return Number(a.id || 0) - Number(b.id || 0)
            })
            this.arr.pending.forEach(element => {                        
              this.crud.formPending.push({              
                check: false,
                id: element.id,                            
                amount: parseFloat(element.amount_total) - parseFloat(element.amount_impute),
                maxAmount: parseFloat(element.amount_total) - parseFloat(element.amount_impute),   
                operation: element.type_voucher.type_balance,
              })
            });

            this.applyPreselectPurchase()
          })                   
        }
      },      
      applyPreselectPurchase() {
        if(!this.preselectPurchaseId) return

        var index = this.crud.formPending.findIndex(element => element.id == this.preselectPurchaseId)
        this.preselectPurchaseId = 0

        if(index < 0) {
          this.$awn.alert("La factura ya no tiene saldo pendiente de imputación");
          return
        }

        this.crud.formPending[index].check = true
        this.validCheck(index)
      },
      calcVoucherPending(item) {
        return parseFloat(item.amount_total) - parseFloat(item.amount_impute)
      },
      validCheck(index) {             
        if(this.crud.formPending[index].check) {          
          this.crud.formPending[index].amount = parseFloat(this.crud.formPending[index].maxAmount).toFixed(2)        
          this.forceUpdateItem()
        }

        this.validImputation(index)
      },
      validAmount(index){       
        if(this.crud.formPending[index].amount=='') {
          this.crud.formPending[index].amount = 0
          this.crud.formPending[index].check = false
        }

        if( parseFloat(this.crud.formPending[index].amount) > parseFloat(this.crud.formPending[index].maxAmount)) {          
          this.crud.formPending[index].amount = parseFloat(this.crud.formPending[index].maxAmount).toFixed(2)
          this.forceUpdateItem()
        }

        if( parseFloat(this.crud.formPending[index].amount) <= 0) {          
          this.crud.formPending[index].amount = parseFloat(this.crud.formPending[index].maxAmount).toFixed(2)          
          this.crud.formPending[index].check = false
          this.forceUpdateItem()
        }        

        this.validImputation(index)
        // Editar el monto no resetea los medios de pago ya cargados: el paso
        // Detalle valida contra el nuevo total (si sobra queda a cuenta, si
        // falta avisa y no deja avanzar).
      },
      validImputation(index) {
        // El tope contra payment.total sólo aplica al modal de imputación de
        // saldo, donde el importe es fijo. En el alta el pago se carga después
        // (y puede venir reseteado en 0): ahí lo valida el paso Detalle.
        if(this.crud.form.operation != 'imputation') return

        if(this.crud.form.payment) {
          if(this.crud.formPending) {            
            var imputation = this.imputationAmount

            var amount = 0
            var valid = parseFloat(this.crud.form.payment.total) - parseFloat(imputation)                        
            if( valid.toFixed(2) < 0) {
              amount = parseFloat(this.crud.formPending[index].amount) - (parseFloat(imputation) - parseFloat(this.crud.form.payment.total))
              this.crud.formPending[index].amount = parseFloat(amount.toFixed(2))
                          
              if(Math.abs(parseFloat(amount.toFixed(2))) <= 0) {
                this.crud.formPending[index].check = false
              }

              var positiveBalance = parseFloat(this.crud.form.payment.total) - parseFloat(this.imputationAmount)
              this.calc.positiveBalance = parseFloat(positiveBalance.toFixed(2))
              this.calc.positiveBalanceFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencyCode}).format(this.calc.positiveBalance)             
              
              this.forceUpdateItem()
            } else {
              amount = parseFloat(this.crud.form.payment.total) - parseFloat(imputation)              
              this.calc.positiveBalance = parseFloat(amount.toFixed(2))
              this.calc.positiveBalanceFormat = Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencyCode}).format(this.calc.positiveBalance)             

              this.forceUpdateItem()
            }
          }
        }        
      },      
      loadFormImpuation() {
        this.crud.form.imputation = []        
        if(this.crud.formPending.length) {
          this.crud.formPending.forEach(element => {                  
            if(element.check && element.amount>0) {              
              this.crud.form.imputation.push({                
                'id': element.id,               
                'amount': element.amount,               
              })                            
            }
          });
        }        
      },
      forceUpdateItem() {
        this.itemForceUpdate = this.itemForceUpdate + 1
      },        

      // SELECT VOUCHER
      searchVoucherBySupplier() {
        if(!this.crud.form.id) {
          if(this.crud.form.suppliers_id && this.crud.form.points_sales_id ) {
            var result = serviceAPI.obtenerVoucherBySupplier({
              'suppliers_id': this.crud.form.suppliers_id,
              'reference': this.crud.form.selectTypeVoucher,
              'point_sale_id': this.crud.form.points_sales_id,
            });
            result.then((response) => {    
              this.crud.form.types_vouchers_id = response.data[0].id							
              this.searchVoucher()                          
            })
            .catch(error => {
              this.$awn.alert(Error.showError(error));
            })   						           
          }
        } else {                                      
          if( this.crud.form.types_vouchers ) {                          
            this.modal.form.title = this.crud.form.types_vouchers.name
            this.modal.form.title = this.modal.form.title + ' ' + this.crud.form.point_sales.point_sale.toString().padStart(4,'0')
            this.modal.form.title = this.modal.form.title + '-' + this.crud.form.number.toString().padStart(8,'0')
          }                   
        }
      },			
      searchVoucher() {
        if(!this.crud.form.id) {
          if(this.crud.form.suppliers_id && this.crud.form.points_sales_id ) {
            var result = serviceAPI.obtenerVoucherById({
              'points_sales_id': this.crud.form.points_sales_id,
              'types_vouchers_id' : this.crud.form.types_vouchers_id,
            });
            result.then((response) => {                   
              this.crud.form.types_vouchers = response.data.type_voucher
              this.crud.form.letter = response.data.type_voucher.letter                    
              this.crud.form.number = response.data.number
          
              if( this.crud.form.types_vouchers ) {              
                this.modal.form.title = this.crud.form.types_vouchers.name
                this.modal.form.title = this.modal.form.title + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
                this.modal.form.title = this.modal.form.title + '-' + this.crud.form.number.toString().padStart(8,'0')
              }                                
            })
          }
        } else {                                      
          if( this.crud.form.types_vouchers ) {                          
            this.modal.form.title = this.crud.form.types_vouchers.name          
            this.modal.form.title = this.modal.form.title + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
            this.modal.form.title = this.modal.form.title + '-' + this.crud.form.number.toString().padStart(8,'0')
          }                   
        }
      },  
    }
  }
</script>
<style>
  .crud-payments-wizard .wizard-header {
    padding: 0px;
  }
  .crud-payments-wizard .wizard-card-footer {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 4px 0;
  }
  .crud-payments-wizard .wizard-card-footer .wizard-footer-left,
  .crud-payments-wizard .wizard-card-footer .wizard-footer-right {
    float: none !important;
  }
  .crud-payments-wizard .wizard-card-footer .wizard-footer-right {
    margin-left: auto;
  }
  .crud-payments-wizard .wizard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 36px;
    padding: 6px 14px;
    border-width: 1px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: var(--app-font-semibold);
    box-shadow: none;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
  }
  .crud-payments-wizard .wizard-footer-left .wizard-btn::before,
  .crud-payments-wizard .wizard-footer-right .wizard-btn::after {
    font-family: 'Material Symbols Rounded';
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-feature-settings: 'liga';
    line-height: 1;
  }
  .crud-payments-wizard .wizard-footer-left .wizard-btn::before {
    content: 'arrow_back';
    margin-right: 6px;
  }
  .crud-payments-wizard .wizard-footer-right .wizard-btn::after {
    content: 'arrow_forward';
    margin-left: 6px;
  }
  .crud-payments-wizard .wizard-footer-left .wizard-btn {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border-strong) !important;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-payments-wizard .wizard-footer-left .wizard-btn:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: var(--app-color-text) !important;
  }
  .crud-payments-wizard .wizard-footer-right .wizard-btn {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    color: #fff !important;
  }
  .crud-payments-wizard .wizard-footer-right .wizard-btn:hover {
    filter: brightness(.94);
  }
  @media (max-width: 767.98px) {
    .crud-payments-wizard .wizard-card-footer {
      gap: 8px;
      padding: 12px 0 0;
    }
    .crud-payments-wizard .wizard-footer-left,
    .crud-payments-wizard .wizard-footer-right {
      display: flex;
      flex: 1 1 0;
    }
    .crud-payments-wizard .wizard-card-footer .wizard-footer-right {
      margin-left: 0;
    }
    .crud-payments-wizard .wizard-footer-left > span,
    .crud-payments-wizard .wizard-footer-right > span {
      display: block;
      width: 100%;
    }
    .crud-payments-wizard .wizard-btn {
      width: 100%;
      min-width: 0;
    }
  }
  .crud-payments-item-input {
    height: 25px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }
  .crud-payments-table-items {
    height: 400px;
    overflow: auto;
  }
  .payments-payments-add-total-final {
    font-weight: 800 !important;
    font-size: 15px !important;
    text-align: right;
  }
</style>
